import { useTranslation } from 'react-i18next';
import {SearchIconNoResults } from './Miscellaneous';

const NoResults = (): any => {
    const { t } = useTranslation();

    return (<>
         <div className="border rounded lockers-plugin-no-search-result-container">
            <SearchIconNoResults/>
            <p>{t('noEasyboxesFound')}</p>
        </div>
    </>
    )
}
export default NoResults;